module.exports = __webpack_public_path__ + "img/logo1.ca93a033.png";